import { useApolloClient } from "@apollo/client";
import { PropsWithChildren } from "react";

import { useAuthProvider } from "./hooks/useAuthProvider";
import { UserContext } from "./useUser";

const AuthProvider = ({ children }: PropsWithChildren) => {
  const apolloClient = useApolloClient();
  const authProvider = useAuthProvider({ apolloClient });

  return <UserContext.Provider value={authProvider}>{children}</UserContext.Provider>;
};

export default AuthProvider;
